/*
 * QISSAAT · Menu click-to-open
 *
 * Problem this solves: the mega menu opened on hover and closed the moment the
 * pointer left the menu item. Moving diagonally from "Shop" towards an item in
 * the panel crosses dead space, so the panel closed before you arrived.
 *
 * Behaviour now (desktop, pointer devices only):
 *   - Hovering a top-level item still opens its panel, as before.
 *   - Once open, the panel STAYS open. It no longer closes when the pointer
 *     drifts off, so diagonal movement is fine.
 *   - Clicking a top-level item with a panel opens it instead of navigating.
 *   - It closes when you: click a link inside the panel, click anywhere outside
 *     the menu, press Escape, or move to a different top-level item.
 *
 * How it works: the theme's own header-menu component closes the panel from a
 * pointerleave handler. This script listens in the CAPTURE phase, so it runs
 * before that handler, and stops the event while a panel is open. Closing is
 * done by re-dispatching pointerleave with the guard lifted, which lets the
 * theme's own teardown run normally (heights, ARIA, underlay) rather than this
 * script second-guessing it.
 *
 * Touch devices are skipped entirely — they use the drawer menu, not hover.
 *
 * To remove this behaviour: delete this file, the <script> line in
 * snippets/qissaat-header.liquid, and the [data-qs-open] block in
 * assets/qissaat-header.css.
 */
(function () {
  'use strict';

  // Hover-capable pointers only. Phones and tablets use the drawer.
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  // While false, the theme's own pointerleave close handler is blocked.
  var allowLeave = false;

  function hasPanel(item) {
    return !!(item && item.querySelector('.mega-menu__list'));
  }

  function openItem(item) {
    var menu = item.closest('header-menu');
    if (!menu) return;

    var previous = menu.querySelector('.menu-list__list-item[data-qs-open]');
    if (previous && previous !== item) previous.removeAttribute('data-qs-open');

    menu.setAttribute('data-qs-open', '');
    item.setAttribute('data-qs-open', '');
  }

  function closeAll() {
    var menus = document.querySelectorAll('header-menu[data-qs-open]');

    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i];
      var item = menu.querySelector('.menu-list__list-item[data-qs-open]');

      menu.removeAttribute('data-qs-open');
      if (item) item.removeAttribute('data-qs-open');

      // Let the theme run its own close, so heights and ARIA stay correct.
      allowLeave = true;
      try {
        if (item) item.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false }));
      } catch (e) {
        /* older browsers without the PointerEvent constructor: the attribute
           removal above still collapses the panel via CSS */
      }
      allowLeave = false;
    }
  }

  // Track which item is open as the theme opens it on hover.
  document.addEventListener(
    'pointerenter',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var item = target.closest('.menu-list__list-item');
      if (!item || !item.closest('header-menu') || !hasPanel(item)) return;

      openItem(item);
    },
    true
  );

  // Block the theme's close-on-leave while a panel is open.
  document.addEventListener(
    'pointerleave',
    function (event) {
      if (allowLeave) return;

      var target = event.target;
      if (!target || !target.closest || !target.closest('header-menu')) return;

      if (document.querySelector('header-menu .menu-list__list-item[data-qs-open]')) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      // A link inside the panel: let it navigate, and close behind it.
      if (target.closest('.mega-menu__list')) {
        closeAll();
        return;
      }

      var link = target.closest('.menu-list__link');
      if (link) {
        var item = link.closest('.menu-list__list-item');

        // Top-level item WITH a panel: open it rather than navigating.
        if (item && hasPanel(item)) {
          event.preventDefault();
          openItem(item);
          try {
            item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
          } catch (e) {
            /* no-op */
          }
          return;
        }

        // Top-level item with no panel: ordinary link, leave it alone.
        return;
      }

      // Anywhere outside the menu closes it.
      if (!target.closest('header-menu')) closeAll();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
